
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "stores/useUser";


export default function LogoutPage() {
    const setUser = useUser(state => state.setUser);
    const navigate = useNavigate();
    const { instance } = useMsal();

    useEffect(() => {
        instance.setActiveAccount(null);
        setUser(null);
        navigate("/");
    }, [])

    return (
        <></>
    )
}